import { render, staticRenderFns } from "./ClinicDoctorSchedule.vue?vue&type=template&id=70709890"
import script from "./ClinicDoctorSchedule.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports